<section class="canvas"
         id="draggable-canvas"
         [class.dragging]="isDragging"
         [class.drag-mode]="mouseDragMode"
         [class.disable-drag]="disableDraggingEvents"
         (mouseup)="onMouseUp($event)"
         (mousedown)="onMouseDown($event)"
         (mousemove)="onMouseMove($event)"
         (wheel)="onWheel($event)">
  <ng-content></ng-content>
</section>
